<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__management')}}</h4>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__management_i')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__risk_level')}}</th>
                <th>{{$t('medium_grant_ev.diligence__management_table_i')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.management_i === row.value}" v-for="(row, index) in tableManagementI" :key="index">
                <td>
                  <radio name="model.management_i"
                         :value="row.value"
                         v-model="EvaluationForm.model.management_i"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.management_i}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_financial_personel" :comments="EvaluationForm.model.comments_financial_personel"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__management_ii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__risk_level')}}</th>
                <th>{{$t('medium_grant_ev.diligence__management_table_ii')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.management_ii === row.value}" v-for="(row, index) in tableManagementIi" :key="index">
                <td>
                  <radio name="model.management_ii"
                         :value="row.value"
                         v-model="EvaluationForm.model.management_ii"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.management_ii}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_employed" :comments="EvaluationForm.model.comments_employed"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__management_iii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__risk_level')}}</th>
                <th>{{$t('medium_grant_ev.diligence__management_table_iii')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.management_iii === row.value}" v-for="(row, index) in tableManagementIii" :key="index">
                <td>
                  <radio name="model.management_iii"
                         :value="row.value"
                         v-model="EvaluationForm.model.management_iii"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.management_iii}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_personel_time" :comments="EvaluationForm.model.comments_personel_time"></comment-box>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tableManagementI: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_i_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_i_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_i_4')},
          {'value': 8, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_i_8')},
        ],
        tableManagementIi: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_ii_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_ii_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_ii_4')},
          {'value': 8, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_ii_8')},
        ],
        tableManagementIii: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_iii_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_iii_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__management_table_iii_4')},
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>